<template>
    <div :class="['page about',{ off: !pageOn }]">
        <!-- <Ham :on="on" @select="hamSelect" /> -->
        <VHeader @ham="on = true;" />
        <div class="page-content" :style="{ 'background-color': backgroundColor }">
            <div v-if="AddMembers" class="add-members" style="position: relative;line-height: 36px;">
                <img :src="joinPage" style="width: 100%;" />
                <p style="text-align:center;font-size:16px;line-height:20px;margin-top: 0px" v-html="joinWords"></p>
                <p style="text-align:center;font-size:16px;line-height:20px;margin-top: 0px"><span style="text-decoration:underline;" @click="pushPage('terms')">Terms and Conditions</span> and <span style="text-decoration:underline" @click="pushPage('privacy')">Privacy Notice</span></p>
                <p style="text-decoration: underline;text-align: center;float: left;width: 100%;margin:10px 0px 35px 0px;display:none" @click="pushPage('terms')">Show Terms & Conditions</p>
                <p class="btn" :style="{ 'margin-top':'35px', backgroundColor: btnColor, color: btnFontColor }" @click="signUp()">JOIN NOW</p>
                <p style="margin-top: 20px;margin-bottom:20px;text-align: center;text-decoration: underline;" @click="signIn()">Sign In</p>
            </div>
            <div v-if="!AddMembers">
                <h2 style="width: 80%;margin: 10%;line-height: 2;font-weight: 400;text-align: center;">We Are not accepting members, do you want to be added to the Wait List ?</h2>
                <input id="name" v-model="name" placeholder="Your Name"  />
                <input id="email" v-model="email" placeholder="Your Email"  />
                <input id="mobile" v-model="mobile" placeholder="Your Mobile"  />
                <p class="btn" @click="addToWait()">Add Me to the List</p>
            </div>
        </div>  
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations, mapState } from 'vuex';
import WebSoc from '@/utils/WebSoc.js';
import Ham from '@/components/Ham.vue'
import Alert from '@/utils/Alert.js'

export default {
    name: 'copper',
    mixins: [ pageOn ],
    components: {
        VHeader,
        Ham
    },
    data () {
        return {
            on: false,
            AddMembers: true,
            name: '',
            email: '',
            mobile: ''
        }
    },
    computed: {
        amount () { return this.$store.state.amount },
        backgroundColor () { return this.$store.state.backgroundColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor },
        joinPage () { return this.$store.state.joinPage },
        client_id () { return this.$store.state.client_id },
        joinWords () { return this.$store.state.joinWords }
    },
    mounted () {
        console.log('this.joinPage',this.joinPage);
    },
    methods: {
        /*
        hamSelect ( page ) {
            this.on = false;
            this.pushPage(page);
            if ( page == 'terms' ) {
                this.$emit('showTerms');
            }
        },
        showTerms () {
            this.$emit('showTerms');
        },
        */
        addToWait () {
            var email = this.email;
            var mobile = this.mobile;
            var name = this.name;
            if ( !email || email.indexOf('@') == - 1 ) return Alert.message('Invlid Email Address');
            if ( !mobile ) return Alert.message('Invalid Mobile Number');
            if ( !name ) return Alert.message('You need to fill in your name');
            
            WebSoc.SEND({ t: 'addWait', data: { name, email, mobile }},() => {

            });

            Alert.message('You have been added to the wait list we will be in touch soon',() => {
                this.name = '';
                this.email = '';
                this.mobile = '';
            });
            
        },
        signIn () {
            Alert.prompt({ type: 'tel', message: 'Enter your mobile number' },phone => {
                if ( !phone ) return;
                phone = phone.replace(/ /g,'');
                if ( isNaN(phone) ) return Alert.message('Invalid mobile number');
                WebSoc.SEND({ t: 'signInAuth', data: { phone }},resp => {
                    resp.error && Alert.message(resp.error);
                    resp.message && Alert.message(resp.message);
                });
            })
        },
        signUp () {
            this.$emit('showDetail');
        },
        /*
        terms () {
            this.$emit('showTerms')
        },
        */
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue'
        ])
    }
}

</script>

<style lang="scss">
@media only screen and (max-device-width:320px) {
    .add-members {
        .copper-welcome-title {
            p:not(.btn)  { font-size:30px !important; }
        }
        line-height: 30px !important;
        p { font-size: 16px !important;  }
    }
}
</style>